import React, { Component } from 'react';
import map from 'lodash.map';
import orderBy from 'lodash.orderby';
import find from 'lodash.find';
import filter from 'lodash.filter';
import { getActChild } from '../../../helpers/ActChildren';
import { ActComments } from './ActComments';

export class ActAttachments extends Component {
	render() {
		const {
			childrens,
			showComment,
			canCommentAndSetOpinion,
			agreementAccepted = false,
			agreementAcceptedRequired = false,
			scrollToAgreement = Function.prototype,
			userId,
			showOpinion = false,
			addCommentOpinion,
			removeCommentOpinion,
			projectId,
			isCommentAdding=false
		} = this.props;
		const childrenOrdered = orderBy(childrens, (c) => c.order);
		const doAktu = find(childrenOrdered, (c) => c.name === 'do-aktu');
		const tytul = find(childrenOrdered, (c) => c.name === 'tytul');
		const podstawaPrawna = find(childrenOrdered, (c) => c.name === 'podstawa-prawna');
		const preambula = find(childrenOrdered, (c) => c.name === 'preambula');
		const children = filter(
			childrenOrdered,
			(c) => c.name !== 'do-aktu' && c.name !== 'tytul' && c.name !== 'podstawa-prawna' && c.name !== 'preambula'
		);

		return (
			<ActComments
				{...this.props}
				showComment={showComment}
				saveComment={(comment) => this.props.saveComment(comment)}
				canCommentAndSetOpinion={canCommentAndSetOpinion}
				addCommentOpinion={addCommentOpinion}
				removeCommentOpinion={removeCommentOpinion}
				projectId={projectId}
				agreementAccepted={agreementAccepted}
				agreementAcceptedRequired={agreementAcceptedRequired}
				scrollToAgreement={scrollToAgreement}
				userId={userId}
				showOpinion={showOpinion}
				isCommentAdding={isCommentAdding}
			>
				{doAktu && <h4 className="text-center" dangerouslySetInnerHTML={{ __html: doAktu.text }} />}
				{tytul && <div className="text text-center" dangerouslySetInnerHTML={{ __html: tytul.text }} />}
				{preambula && <div className="text text-center" dangerouslySetInnerHTML={{ __html: preambula.text }} />}
				{podstawaPrawna && (
					<div className="text text-center" dangerouslySetInnerHTML={{ __html: podstawaPrawna.text }} />
				)}
				{map(children, (child) =>
					getActChild(child, {
						canCommentAndSetOpinion,
						showComment,
						agreementAccepted,
						agreementAcceptedRequired,
						scrollToAgreement,
						userId,
						saveComment: (comment) => this.props.saveComment(comment),
						showOpinion,
						addCommentOpinion,
						removeCommentOpinion,
						projectId,
						isCommentAdding
					})
				)}
			</ActComments>
		);
	}
}
